import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Container } from '@/components/generals/container'
import { Logo } from '@/components/generals/logo'
import { company, legalNavigation, mainNavigation } from '@/constants/site'

const linkClass = 'inline-flex min-h-8 items-center text-kalk-50/85 transition-colors duration-200 hover:text-kalk-50 hover:underline hover:underline-offset-4'

export const Footer: FC = (): ReactNode => {
    return (
        <footer id='seitenende' className='surface-dark bg-petrol-950 text-kalk-50'>
            <Container className='py-16 md:py-20'>
                <div className='grid grid-cols-1 gap-12 lg:grid-cols-12'>
                    <div className='lg:col-span-5'>
                        <Logo />

                        <p className='mt-8 font-heading stretch-wide text-2xl font-semibold tracking-[-0.02em] md:text-3xl'>
                            Build. Scale. Connect.
                        </p>

                        <p className='mt-3 max-w-sm text-sm leading-relaxed text-petrol-200'>
                            Unternehmerische Beteiligungsgesellschaft mit Sitz in Mainz-Kastel.
                        </p>
                    </div>

                    <div className='grid grid-cols-1 gap-10 sm:grid-cols-3 lg:col-span-7'>
                        <div>
                            <h2 className='font-mono text-xs font-medium tracking-[0.14em] text-petrol-200 uppercase'>
                                Anschrift
                            </h2>

                            <address className='mt-4 text-sm leading-relaxed not-italic'>
                                {company.legalName}
                                <br />
                                {company.street}
                                <br />
                                {company.postalCode} {company.city}
                                <br />
                                {company.country}
                            </address>
                        </div>

                        <div>
                            <h2 className='font-mono text-xs font-medium tracking-[0.14em] text-petrol-200 uppercase'>
                                Register
                            </h2>

                            <p className='mt-4 text-sm leading-relaxed'>
                                {company.registerCourt}
                                <br />
                                {company.registerNumber}
                            </p>
                        </div>

                        <nav aria-label='Fußzeilennavigation'>
                            <h2 className='font-mono text-xs font-medium tracking-[0.14em] text-petrol-200 uppercase'>
                                Seiten
                            </h2>

                            <ul className='mt-3 flex flex-col text-sm'>
                                {mainNavigation.map(item => (
                                    <li key={item.href}>
                                        <Link href={item.href} className={linkClass}>
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className='mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-petrol-200 sm:flex-row sm:items-center sm:justify-between'>
                    <p>
                        © <span suppressHydrationWarning>{new Date().getFullYear()}</span> {company.legalName} · {company.domain}
                    </p>

                    <ul className='flex flex-wrap gap-x-6 gap-y-1'>
                        {legalNavigation.map(item => (
                            <li key={item.href}>
                                <Link href={item.href} className={linkClass}>
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>
        </footer>
    )
}
